module.exports = __webpack_public_path__ + "img/fhqr2.f51547b4.png";